import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "MedicalWebPage",
   "@id": "https://www.futurefamilyai.com/surrogacy/coordinator-role-wellness-app/#webpage",
   "url": "https://www.futurefamilyai.com/surrogacy/coordinator-role-wellness-app/",
   "name": "Surrogacy Coordinator App | FutureFamilyAI",
   "description": "How coordinators can help surrogates with enrollment, reminders and logistics — without accessing private health details they haven't shared.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Pooja Patel, MD",
    "jobTitle": "Surrogacy & Fertility Content Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#pooja-patel",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Surrogate Wellness",
     "item": "https://www.futurefamilyai.com/surrogacy/wellness-monitoring/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Coordinator Role",
     "item": "https://www.futurefamilyai.com/surrogacy/coordinator-role-wellness-app/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "What does a surrogacy coordinator do?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Coordinators manage logistics, communication and support across the journey; clinical decisions stay with medical teams."
     }
    },
    {
     "@type": "Question",
     "name": "Can coordinators see surrogate health data in FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only what the surrogate explicitly shares."
     }
    },
    {
     "@type": "Question",
     "name": "Does the app replace our case management system?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. It complements your existing tools."
     }
    },
    {
     "@type": "Question",
     "name": "Who answers medical questions?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "The surrogate's clinician and the care team, not the coordinator."
     }
    },
    {
     "@type": "Question",
     "name": "Is there a fee for agencies?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No partner fees."
     }
    },
    {
     "@type": "Question",
     "name": "Can we see which surrogates are enrolled?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, enrollment status is visible to your agency with surrogate consent."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function SurrogacyCoordinatorRoleWellnessAppPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/surrogacy/wellness-monitoring">
                Surrogate Wellness
              </Link>
              <span>›</span>
              <span>Coordinator Role</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                A surrogacy coordinator app should help coordinators support
                surrogates with enrollment, reminders and logistics while
                respecting medical privacy.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Surrogacy agency coordinators</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Patient-generated health data is health-related data
                      created, recorded or gathered by patients to help address
                      a health concern. (ONC / HealthIT.gov)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Logistics view by default · Health details only with
                      consent · Fewer status calls
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">SURROGACY GUIDE</span>
            <h1>Surrogacy Coordinator App — Support Without Overreach</h1>
            <p className="ffh-answer speakable-content">
              A surrogacy coordinator app should help coordinators support
              surrogates with enrollment, reminders and logistics while
              respecting medical privacy. In FutureFamilyAI, coordinators see
              only what the surrogate authorizes, never diagnose or change
              medical instructions, and hand clinical questions to the treating
              team. The result: fewer missed tasks and stronger trust. Request a
              partner pilot for your agency.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#pooja-patel">Dr. Pooja Patel, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Surrogacy coordinator supporting a surrogate with logistics and reminders"
              >
                <figcaption>
                  <b>Photo slot</b> · Surrogacy coordinator at a desk on a
                  friendly phone call, headset, notepad; warm office light. No
                  screen text.
                  <br />
                  <b>Alt:</b> Surrogacy coordinator supporting a surrogate with
                  logistics and reminders
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Patient-generated health data is health-related data
                    created, recorded or gathered by patients to help address a
                    health concern.
                    <cite>
                      Source:{" "}
                      <a href="https://www.healthit.gov/topic/scientific-initiatives/pcor/patient-generated-health-data-pghd">
                        ONC / HealthIT.gov
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What coordinators can do</h2>
                <ul>
                  <li>Help with enrollment and device setup</li>
                  <li>See appointment and task reminders</li>
                  <li>View summaries the surrogate shares</li>
                  <li>Route clinical questions to the care team</li>
                </ul>
              </section>
              <section id="s2">
                <h2>What coordinators should not do</h2>
                <ul>
                  <li>Interpret readings or symptoms</li>
                  <li>Change medical instructions</li>
                  <li>Access private details without permission</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>What does a surrogacy coordinator do?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Coordinators manage logistics, communication and support
                        across the journey; clinical decisions stay with medical
                        teams.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can coordinators see surrogate health data in
                      FutureFamilyAI?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>Only what the surrogate explicitly shares.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does the app replace our case management system?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>No. It complements your existing tools.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Who answers medical questions?</summary>
                    <div className="ffh-ans">
                      <p>
                        The surrogate&apos;s clinician and the care team, not
                        the coordinator.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is there a fee for agencies?</summary>
                    <div className="ffh-ans">
                      <p>No partner fees.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we see which surrogates are enrolled?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes, enrollment status is visible to your agency with
                        surrogate consent.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">PP</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Pooja Patel, MD</h3>
                  <p>
                    Surrogacy &amp; Fertility Content Author, FutureFamilyAI.
                    Dr. Pooja Patel, MD, writes FutureFamilyAI&apos;s surrogacy
                    and fertility content. Her work across the Surrogacy4All
                    network focuses on gestational carriers, IVF preparation and
                    family-building pathways.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/surrogacy/wellness-monitoring">
                    Surrogate Wellness →
                  </Link>
                  <Link to="/surrogacy/surrogate-health-monitoring-app">
                    Surrogate Health Monitoring App →
                  </Link>
                  <Link to="/surrogacy/surrogate-blood-pressure-tracking">
                    Surrogate Blood Pressure Tracking →
                  </Link>
                  <Link to="/surrogacy/intended-parent-updates">
                    Intended Parent Updates →
                  </Link>
                  <Link to="/surrogacy/independent-surrogate-agencies">
                    Independent Surrogates →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What coordinators can do</a>
                  </li>
                  <li>
                    <a href="#s2">What coordinators should not do</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
